export default {
  path: 'manage-role',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Manage Role',
      component: () => import('@/views/menus/manageRole/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
